module.exports = __webpack_public_path__ + "img/mortar_symbol.0af1d04f.svg";